import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

const backendURL = `${AWS_API_URL}/bookings`;

export async function getLaundryBookings(resourceId) {
  let url = `${backendURL}`;
  if (resourceId) url += `?resourceId=${resourceId}`;

  return getRequest(url, await authorize());
}
